import React from "react";
import "./footer.css";
import footerImg from "../../assets/footerImg.png";
import footerDiscordImg from "../../assets/footerDiscordImg.svg";
import footerTwitterImg from "../../assets/footerTwitterImg.svg";
import footerInstagramImg from "../../assets/footerInstagramImg.svg";
const Footer = () => {
  return (
    <div className="footer-main-wrapper">
      <div className="footer-inner-wrapper">
        <div className="image-wrapper">
          <img src={footerImg} alt="footerImg" />
        </div>
        <p className="copyright-text">
          © 2021 Party Potato Club, ALL RIGHTS RESERVED.
        </p>
        <div className="footer-icons">
          <a href="https://discord.gg/nu9BZtVtTU" target="_blank">
            <img src={footerDiscordImg} alt="footerDiscordImg" />
          </a>
          &nbsp; &nbsp; &nbsp;
          <a href="https://twitter.com/PartyPotatoNFT" target="_blank">
            <img src={footerTwitterImg} alt="footerTwitterImg" />
          </a>
          &nbsp; &nbsp; &nbsp;
          <a href="https://www.instagram.com/partypotatonft/" target="_blank">
            <img src={footerInstagramImg} alt="footerInstagramImg" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
